import script from "./packageDetalisPopUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./packageDetalisPopUp.vue?vue&type=script&lang=ts&setup=true"

import "./packageDetalisPopUp.vue?vue&type=style&index=0&id=717b2316&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717b2316"]])

export default __exports__